/* @flow */
export * as Either from './Either.js';
export { either } from './Either.js';

export * from './IO.js';
export * as Validation from './Validation.js';

/**
 * Create an isomorphism using to functions. This provides an interface for
 * converting back and forth between different data representations.
 */
export const Iso = (to: Function, from: Function) => ({ to, from });




// WEBPACK FOOTER //
// ./web_modules/trustar/fp/index.js